export default __webpack_public_path__ + "static/media/elevate-red-banner-1.ca6780aa.jpg";